/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageShowResponse } from '../../models/image-show-response';

export interface GetImageShow$Params {
  id: string;
}

export function getImageShow(http: HttpClient, rootUrl: string, params: GetImageShow$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageShowResponse>> {
  const rb = new RequestBuilder(rootUrl, getImageShow.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageShowResponse>;
    })
  );
}

getImageShow.PATH = '/v1/image/{id}';
